import { Injectable } from '@angular/core';
import * as SecureLS from 'secure-ls';


@Injectable({
  providedIn: 'root'
})
export class SessionService {
  token: any;
  refreshToken: any;
  secureLs: SecureLS;
  isRefreshing = false


  constructor() { 
   this.secureLs= new SecureLS({encodingType: 'aes', encryptionSecret: 'my-secret-key-2'});
    this.getToken();
  }

  async getToken() {
    await this.getItem('authorization')
      .then(authorization => {
        if (authorization) {
          this.token = authorization['access_token']
          this.refreshToken = authorization['refresh_token']
        }
      })
      .catch(err => {
        this.token = null
      })
  }

  getItem<T = any>(key: string): Promise<any> {
    let sessionData = this.secureLs.get(key);

    if (sessionData !== '') return Promise.resolve(sessionData)
    else return Promise.resolve(false)
  }

  setItem(key, value) {
    this.secureLs.set(key, value);
  }

  removeSessionOnStorage() {
    this.token = null;
    this.removeItem('session')
    this.removeItem('authorization')
  }

  removeItem(key) {
    this.secureLs.remove(key)
    this.secureLs.removeAll()
  }

}
